import { Tabs } from "@shared/ui/tabs";
import DashboardHeader from "./dashboardHeader";

import ComplianceQualityCard from "./Tabs/compliance/compliance";
import Financial from "./Tabs/financial/financial";
import OMDashboard from "./Tabs/oAndM/oAndM";
import Overview from "./Tabs/overview/overview";

const AssetManagementDashboard = () => {
  // Tab configuration using the shared tab service structure
  const dashboardTabComponents = {
    overview: {
      label: "Overview",
      shortLabel: "Overview",
      component: <Overview />,
    },
    financial: {
      label: "Financial",
      shortLabel: "Financial",
      component: <Financial />,
    },
    maintenance: {
      label: "O&M",
      shortLabel: "O&M",
      component: <OMDashboard />,
    },
    // energy: {
    //   label: "Energy",
    //   shortLabel: "Energy",
    //   component: <EnergyUsageCard />,
    // },
    compliance: {
      label: "Compliance",
      shortLabel: "Compliance",
      component: <ComplianceQualityCard />,
    },
  };

  // Simple URL mapping (tab value maps to same URL param)
  const urlMapping = {
    overview: "overview",
    financial: "financial",
    maintenance: "maintenance",
    energy: "energy",
    inventory: "inventory",
    compliance: "compliance",
  };

  return (
    <div className="p-2">
      <DashboardHeader />

      <Tabs
        defaultValue="overview"
        urlMapping={urlMapping}
        tabComponents={dashboardTabComponents}
        tabsListClassName="grid w-full lg:w-auto grid-cols-3 lg:grid-cols-4 mt-4"
        idPrefix="dashboard-tab"
        disableUrlSync={false} // Enable URL synchronization
      />
    </div>
  );
};

export default AssetManagementDashboard;
